webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
'v0.4.6 Geetest Inc.';


(function (window) {
  'use strict';

  if (typeof window === 'undefined') {
    throw new Error('Geetest requires browser environment');
  }

  var document = window.document;
  var Math = window.Math;
  var head = document.getElementsByTagName('head')[0];

  function _Object(obj) {
    this._obj = obj;
  }

  _Object.prototype = {
    _each: function _each(process) {
      var _obj = this._obj;
      for (var k in _obj) {
        if (_obj.hasOwnProperty(k)) {
          process(k, _obj[k]);
        }
      }
      return this;
    }
  };

  function Config(config) {
    var self = this;
    new _Object(config)._each(function (key, value) {
      self[key] = value;
    });
  }

  Config.prototype = {
    api_server: 'api.geetest.com',
    protocol: 'http://',
    typePath: '/gettype.php',
    fallback_config: {
      slide: {
        static_servers: ['static.geetest.com', 'dn-staticdown.qbox.me'],
        type: 'slide',
        slide: '/static/js/geetest.0.0.0.js'
      },
      fullpage: {
        static_servers: ['static.geetest.com', 'dn-staticdown.qbox.me'],
        type: 'fullpage',
        fullpage: '/static/js/fullpage.0.0.0.js'
      }
    },
    _get_fallback_config: function _get_fallback_config() {
      var self = this;
      if (isString(self.type)) {
        return self.fallback_config[self.type];
      } else if (self.new_captcha) {
        return self.fallback_config.fullpage;
      } else {
        return self.fallback_config.slide;
      }
    },
    _extend: function _extend(obj) {
      var self = this;
      new _Object(obj)._each(function (key, value) {
        self[key] = value;
      });
    }
  };
  var isNumber = function isNumber(value) {
    return typeof value === 'number';
  };
  var isString = function isString(value) {
    return typeof value === 'string';
  };
  var isBoolean = function isBoolean(value) {
    return typeof value === 'boolean';
  };
  var isObject = function isObject(value) {
    return (typeof value === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(value)) === 'object' && value !== null;
  };
  var isFunction = function isFunction(value) {
    return typeof value === 'function';
  };

  var callbacks = {};
  var status = {};

  var random = function random() {
    return parseInt(Math.random() * 10000) + new Date().valueOf();
  };

  var loadScript = function loadScript(url, cb) {
    var script = document.createElement('script');
    script.charset = 'UTF-8';
    script.async = true;

    script.onerror = function () {
      cb(true);
    };
    var loaded = false;
    script.onload = script.onreadystatechange = function () {
      if (!loaded && (!script.readyState || 'loaded' === script.readyState || 'complete' === script.readyState)) {

        loaded = true;
        setTimeout(function () {
          cb(false);
        }, 0);
      }
    };
    script.src = url;
    head.appendChild(script);
  };

  var normalizeDomain = function normalizeDomain(domain) {
    return domain.replace(/^https?:\/\/|\/$/g, '');
  };
  var normalizePath = function normalizePath(path) {
    path = path.replace(/\/+/g, '/');
    if (path.indexOf('/') !== 0) {
      path = '/' + path;
    }
    return path;
  };
  var normalizeQuery = function normalizeQuery(query) {
    if (!query) {
      return '';
    }
    var q = '?';
    new _Object(query)._each(function (key, value) {
      if (isString(value) || isNumber(value) || isBoolean(value)) {
        q = q + encodeURIComponent(key) + '=' + encodeURIComponent(value) + '&';
      }
    });
    if (q === '?') {
      q = '';
    }
    return q.replace(/&$/, '');
  };
  var makeURL = function makeURL(protocol, domain, path, query) {
    domain = normalizeDomain(domain);

    var url = normalizePath(path) + normalizeQuery(query);
    if (domain) {
      url = protocol + domain + url;
    }

    return url;
  };
  var load = function load(protocol, domains, path, query, cb) {
    var tryRequest = function tryRequest(at) {

      var url = makeURL(protocol, domains[at], path, query);
      loadScript(url, function (err) {
        if (err) {
          if (at >= domains.length - 1) {
            cb(true);
          } else {
            tryRequest(at + 1);
          }
        } else {
          cb(false);
        }
      });
    };
    tryRequest(0);
  };
  var jsonp = function jsonp(domains, path, config, callback) {
    if (isObject(config.getLib)) {
      config._extend(config.getLib);
      callback(config);
      return;
    }
    if (config.offline) {
      callback(config._get_fallback_config());
      return;
    }

    var cb = 'geetest_' + random();
    window[cb] = function (data) {
      if (data.status === 'success') {
        callback(data.data);
      } else if (!data.status) {
        callback(data);
      } else {
        callback(config._get_fallback_config());
      }
      window[cb] = undefined;
      try {
        delete window[cb];
      } catch (e) {}
    };
    load(config.protocol, domains, path, {
      gt: config.gt,
      callback: cb
    }, function (err) {
      if (err) {
        callback(config._get_fallback_config());
      }
    });
  };
  var throwError = function throwError(errorType, config) {
    var errors = {
      networkError: '网络错误',
      gtTypeError: 'gt字段不是字符串类型'
    };
    if (typeof config.onError === 'function') {
      config.onError(errors[errorType]);
    } else {
      throw new Error(errors[errorType]);
    }
  };
  var detect = function detect() {
    return window.Geetest || document.getElementById('gt_lib');
  };
  if (detect()) {
    status.slide = 'loaded';
  }
  window.initGeetest = function (userConfig, callback) {
    var config = new Config(userConfig);
    if (userConfig.https) {
      config.protocol = 'https://';
    } else if (!userConfig.protocol) {
      config.protocol = window.location.protocol + '//';
    }

    if (userConfig.gt === '050cffef4ae57b5d5e529fea9540b0d1' || userConfig.gt === '3bd38408ae4af923ed36e13819b14d42') {
      config.apiserver = 'yumchina.geetest.com/';
      config.api_server = 'yumchina.geetest.com';
    }
    if (isObject(userConfig.getType)) {
      config._extend(userConfig.getType);
    }
    jsonp([config.api_server || config.apiserver], config.typePath, config, function (newConfig) {
      var type = newConfig.type;
      var init = function init() {
        config._extend(newConfig);
        callback(new window.Geetest(config));
      };
      callbacks[type] = callbacks[type] || [];
      var s = status[type] || 'init';
      if (s === 'init') {
        status[type] = 'loading';
        callbacks[type].push(init);
        load(config.protocol, newConfig.static_servers || newConfig.domains, newConfig[type] || newConfig.path, null, function (err) {
          if (err) {
            status[type] = 'fail';
            throwError('networkError', config);
          } else {
            status[type] = 'loaded';
            var cbs = callbacks[type];
            for (var i = 0, len = cbs.length; i < len; i = i + 1) {
              var cb = cbs[i];
              if (isFunction(cb)) {
                cb();
              }
            }
            callbacks[type] = [];
          }
        });
      } else if (s === 'loaded') {
        init();
      } else if (s === 'fail') {
        throwError('networkError', config);
      } else if (s === 'loading') {
        callbacks[type].push(init);
      }
    });
  };
})(window);

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      baseUrl: 'http://sso.tuling123.com/sso-api',
      ReturnURl: ''
    };
  },
  created: function created() {
    if (this.getUrlFn('ReturnURL')) {
      this.ReturnURl = this.getUrlFn('ReturnURL');
      localStorage.setItem('ReturnURL', this.getUrlFn('ReturnURL'));
    } else {
      if (localStorage.getItem('ReturnURL')) {
        this.ReturnURl = localStorage.getItem('ReturnURL');
      } else {
        this.ReturnURl = 'http://www.tuling123.com/member/index.jhtml';
      }
    }
    this.ReturnURl = unescape(this.ReturnURl);
  },

  methods: {
    getUrlFn: function getUrlFn(name) {
      var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
      var r = window.location.search.substr(1).match(reg);
      if (r != null) {
        return unescape(r[2]);
      }
      return null;
    }
  }
});

/***/ }),
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(94)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(58),
  /* template */
  __webpack_require__(106),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-55f8c956",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(95)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(56),
  /* template */
  __webpack_require__(107),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-56d694c9",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(93)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(51),
  /* template */
  __webpack_require__(105),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2e363812",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(91)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(53),
  /* template */
  __webpack_require__(103),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-13cef8c9",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(96)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(54),
  /* template */
  __webpack_require__(108),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6007e4f2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(98)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(57),
  /* template */
  __webpack_require__(110),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-f28f08d6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_router__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_resource__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_login_login_vue__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_login_login_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_login_login_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_register_register_vue__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_register_register_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_register_register_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_findPas_findPas_vue__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_findPas_findPas_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_findPas_findPas_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_findPas_newPas_vue__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_findPas_newPas_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_findPas_newPas_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__css_reset_css__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__css_reset_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__css_reset_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__js_geetest_js__ = __webpack_require__(8);












__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.options.emulateJSON = true;

var router = new __WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{ path: '/sso-web/login', name: 'login', component: __WEBPACK_IMPORTED_MODULE_4__components_login_login_vue___default.a }, { path: '/sso-web/index.html', name: 'login', component: __WEBPACK_IMPORTED_MODULE_4__components_login_login_vue___default.a }, { path: '/sso-web/register', name: 'register', component: __WEBPACK_IMPORTED_MODULE_5__components_register_register_vue___default.a }, { path: '/sso-web/findPas', name: 'findPas', component: __WEBPACK_IMPORTED_MODULE_6__components_findPas_findPas_vue___default.a }, { path: '/sso-web/newPas', name: 'newPas', component: __WEBPACK_IMPORTED_MODULE_7__components_findPas_newPas_vue___default.a }, { path: '*', redirect: '/sso-web/index.html' }],
  linkActiveClass: 'active'
});

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: router,
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
}).$mount('#app');

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_header_header_vue__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_header_header_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_header_header_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_login_login_vue__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_login_login_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_login_login_vue__);





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      loginShow: true,
      name: '欢迎登录',
      onoff: false
    };
  },
  created: function created() {
    if (this.$route.name === 'login') {
      this.onoff = false;
      this.name = '欢迎登录';
      document.getElementsByTagName('title')[0].innerHTML = '登录';
    } else {
      this.onoff = true;
      this.name = '欢迎注册';
      document.getElementsByTagName('title')[0].innerHTML = '注册';
    }
  },

  components: {
    login: __WEBPACK_IMPORTED_MODULE_1__components_login_login_vue___default.a,
    'v-header': __WEBPACK_IMPORTED_MODULE_0__components_header_header_vue___default.a
  },
  methods: {
    loginFn: function loginFn() {
      this.onoff = !this.onoff;
      if (this.onoff) {
        this.name = '欢迎注册';
        document.getElementsByTagName('title')[0].innerHTML = '注册';
      } else {
        this.name = '欢迎登录';
        document.getElementsByTagName('title')[0].innerHTML = '登录';
      }
    },
    changest: function changest() {
      this.name = '欢迎注册';
      this.onoff = true;
      document.getElementsByTagName('title')[0].innerHTML = '注册';
    },
    forget: function forget() {
      this.name = '忘记密码';
      this.onoff = true;
      document.getElementsByTagName('title')[0].innerHTML = '忘记密码';
    }
  }
});

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    alertshow: {
      type: Boolean
    }
  },
  methods: {
    close: function close() {
      this.$emit('close');
    },
    agree: function agree() {
      this.$emit('agree');
    },
    unagree: function unagree() {
      this.$emit('unagree');
    }
  }
});

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__successalert_successalert_vue__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__successalert_successalert_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__successalert_successalert_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__js_geetest_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__js_public_js__ = __webpack_require__(9);






/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_2__js_public_js__["a" /* default */]],
  components: {
    successalert: __WEBPACK_IMPORTED_MODULE_0__successalert_successalert_vue___default.a
  },
  data: function data() {
    return {
      model: 'first',
      errorShow: false,
      errorMsg: '',
      phone: '',
      id: '',
      jcshow: false,
      isphone: true,
      code: '',
      sendNum: 60,
      pass: '',
      repass: '',
      nu: '',
      show: false,
      msg: '恭喜你，密码修改成功！'
    };
  },
  created: function created() {
    var _this = this;
    this.toCode();
    this.id = this.uuid();
    this.$http.post(_this.baseUrl + '/geetest/v3', { id: _this.id }, { credentials: true }).then(function (res) {
      if (res.body.type === 'success') {
        window.initGeetest({
          gt: res.body.data.gt,
          challenge: res.body.data.challenge,
          new_captcha: res.body.data.new_captcha,
          product: 'popup',
          width: '100%',
          offline: !res.body.data.success
        }, _this.handlerPopup);
      } else {
        _this.errorMsg = '网络错误，请稍后再试';
        _this.errorShow = true;
      }
    }, function () {
      _this.errorMsg = '网络错误，请稍后再试';
      _this.errorShow = true;
    });
  },

  methods: {
    sure: function sure() {
      var _this = this;
      var re = /^\d+$/;
      var re1 = /^[a-zA-Z]+$/;
      var re2 = /^[`~!@#\$%\^&\*\(\)_\+<>\?:"\{\},\.\\\/;'\[\]！。；、’“”]+$/;
      var val = this.pass;
      var len = val.length;
      if (re.test(val) || re1.test(val) || re2.test(val) || len > 16 || len < 6) {
        this.errorMsg = '密码需要6-16位，且必须包含两种以上字符';
        this.errorShow = true;
        return;
      }
      this.errorShow = false;
      if (this.pass !== this.repass) {
        this.errorMsg = '两次输入的密码不一样，请重新输入';
        this.errorShow = true;
        return;
      }
      this.$http.post(_this.baseUrl + '/find/password/modify/1', { mobile: this.phone, code: this.code, password: this.pass }, { credentials: true }).then(function (res) {
        if (res.body.type === 'success') {
          _this.show = true;
          window.location = '/sso-web/';
        } else {
          _this.errorMsg = '修改密码失败';
          _this.errorShow = true;
        }
      }, function () {
        _this.errorMsg = '网络错误，请稍后再试';
        _this.errorShow = true;
      });
    },
    resendno: function resendno() {
      this.model = 'first';
      this.errorShow = false;
      this.phone = '';
    },
    resend: function resend() {
      if (this.sendNum === 0) {
        this.model = 'first';
      }
    },
    toCode: function toCode() {
      var _this = this;
      var i = 60;
      this.sendNum = i;
      clearInterval(this.nu);
      this.nu = setInterval(function () {
        i--;
        _this.sendNum = i;
        if (i === 0) {
          clearInterval(_this.nu);
        }
      }, 1000);
    },
    subcode: function subcode() {
      var _this = this;
      if (_this.code.length !== 6) {
        _this.errorShow = true;
        _this.errorMsg = '请输入正确的验证码';
      } else {
        _this.$http.post(_this.baseUrl + '/find/password/validate/1', { mobile: _this.phone, code: _this.code }, { credentials: true }).then(function (res) {
          if (res.body.type === 'success') {
            _this.model = 'four';
          } else {
            _this.errorShow = true;
            _this.errorMsg = '请输入正确的验证码';
          }
        }, function () {
          _this.errorShow = true;
          _this.errorMsg = '网络错误，请稍后重试';
        });
      }
    },
    uuid: function uuid() {
      function S4() {
        return ((1 + Math.random()) * 0x10000 | 0).toString(16).substring(1);
      }
      return S4() + S4() + S4() + S4() + S4() + S4() + S4() + S4();
    },
    handlerPopup: function handlerPopup(captchaObj) {
      var _this = this;
      captchaObj.appendTo('.jtocode');
      captchaObj.onSuccess(function () {
        var validate = captchaObj.getValidate();

        _this.$http.post(_this.baseUrl + '/common/exist-user', { u: _this.phone }, { credentials: true }).then(function (res) {
          if (res.body.type === 'success') {
            if (res.body.data === true) {
              _this.errorShow = false;

              if (_this.isphone) {
                _this.$http.post(_this.baseUrl + '/find/password/send/1', { geetest_challenge: validate.geetest_challenge, geetest_validate: validate.geetest_validate, geetest_seccode: validate.geetest_seccode, mobile: _this.phone }, { credentials: true }).then(function (res) {
                  _this.jcshow = false;
                  captchaObj.reset();
                  if (res.body.type === 'success') {
                    _this.model = 'second';
                    _this.toCode();
                  } else {
                    _this.errorShow = true;
                    _this.errorMsg = '操作错误，请稍后重试';
                  }
                }, function () {
                  _this.errorMsg = '网络错误，请稍后重试';
                  _this.errorShow = true;
                });
              } else {
                _this.$http.post(_this.baseUrl + '/find/password/send/2', { geetest_challenge: validate.geetest_challenge, geetest_validate: validate.geetest_validate, geetest_seccode: validate.geetest_seccode, email: _this.phone, redirect_uri: window.location.href.replace(/findPas/, 'newPas') }, { credentials: true }).then(function (res) {
                  _this.jcshow = false;
                  captchaObj.reset();
                  if (res.body.type === 'success') {
                    _this.model = 'third';
                    _this.toCode();
                  } else if (res.body.code === 11140302) {
                    _this.errorShow = true;
                    _this.errorMsg = '邮箱不存在';
                  } else {
                    _this.errorShow = true;
                    _this.errorMsg = '操作错误';
                  }
                }, function () {
                  _this.errorMsg = '网络错误，请稍后重试';
                  _this.errorShow = true;
                });
              }
            } else {
              captchaObj.reset();
              _this.errorShow = true;
              _this.errorMsg = '账号不存在';
            }
          } else {
            captchaObj.reset();
            _this.errorShow = true;
            _this.errorMsg = '操作错误，请重试';
          }
        }, function () {
          _this.errorMsg = '网络错误，请稍后重试';
          _this.errorShow = true;
        });
      });
    },
    sendMsg: function sendMsg() {
      var phonetest = /^1[0-9]{10}$/;
      var emailtest = /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
      if (phonetest.test(this.phone)) {
        this.jcshow = true;
        this.errorShow = false;
        this.isphone = true;
      } else if (emailtest.test(this.phone)) {
        this.jcshow = true;
        this.errorShow = false;
        this.isphone = false;
      } else {
        this.jcshow = false;
        this.errorMsg = '请输入正确的手机号码/邮箱';
        this.errorShow = true;
      }
    }
  }
});

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__js_public_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__successalert_successalert_vue__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__successalert_successalert_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__successalert_successalert_vue__);





/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__js_public_js__["a" /* default */]],
  components: {
    successalert: __WEBPACK_IMPORTED_MODULE_1__successalert_successalert_vue___default.a
  },
  data: function data() {
    return {
      errorMsg: '',
      errorShow: false,
      pass: '',
      repass: '',
      show: false,
      msg: '恭喜你，密码修改成功！',
      e: '',
      code: ''
    };
  },
  created: function created() {
    this.e = this.getUrlFn('e');
    this.code = this.getUrlFn('code');
  },

  methods: {
    sure: function sure() {
      var _this = this;
      var re = /^\d+$/;
      var re1 = /^[a-zA-Z]+$/;
      var re2 = /^[`~!@#\$%\^&\*\(\)_\+<>\?:"\{\},\.\\\/;'\[\]！。；、’“”]+$/;
      var val = this.pass;
      var len = val.length;
      if (re.test(val) || re1.test(val) || re2.test(val) || len > 16 || len < 6) {
        this.errorMsg = '密码需要6-16位，且必须包含两种以上字符';
        this.errorShow = true;
        return;
      }
      this.errorShow = false;
      if (this.pass !== this.repass) {
        this.errorMsg = '两次输入的密码不一样，请重新输入';
        this.errorShow = true;
        return;
      }
      this.$http.post(_this.baseUrl + '/find/password/modify/2', { e: this.e, code: this.code, password: this.pass }, { credentials: true }).then(function (res) {
        if (res.body.type === 'success') {
          _this.show = true;
          window.location = '/sso-web/';
        } else {
          _this.errorMsg = '修改密码失败';
          _this.errorShow = true;
        }
      }, function () {
        _this.errorMsg = '网络错误，请稍后重试';
        _this.errorShow = true;
      });
    }
  }
});

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    name: {
      type: String
    },
    onoff: {
      type: Boolean
    }
  },
  data: function data() {
    return {};
  },

  methods: {
    loginFn: function loginFn() {
      this.$emit('loginFn');
    }
  }
});

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__js_public_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__js_geetest_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);






/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__js_public_js__["a" /* default */]],
  props: {
    loginShow: {
      type: Boolean
    }
  },
  data: function data() {
    return {
      name: '',
      pas: '',
      errorMsg: '',
      errorShow: false,
      code: '',
      codeshow: false,
      id: ''
    };
  },
  created: function created() {
    var _this = this;
    this.id = this.uuid();
    __WEBPACK_IMPORTED_MODULE_2_jquery___default.a.ajax({
      url: _this.baseUrl + '/geetest/v3',
      type: 'POST',
      dataType: 'json',
      data: { id: _this.id },
      xhrFields: {
        withCredentials: true
      },
      success: function success(res) {
        if (res.type === 'success') {
          window.initGeetest({
            gt: res.data.gt,
            challenge: res.data.challenge,
            new_captcha: res.data.new_captcha,
            product: 'popup',
            width: '100%',
            offline: !res.data.success
          }, _this.handlerPopup);
        }
      }
    });

    this.$nextTick(function () {
      this.code = this.getUrlFn('code');
      var name = this.getUrlFn('name');
      if (this.code && name === 'qq') {
        this.loginQQ();
      } else if (this.code && name === 'wei') {
        this.loginWEI();
      } else if (this.code && name === 'bo') {
        this.loginQQ();
      }
    });
  },

  methods: {
    uuid: function uuid() {
      function S4() {
        return ((1 + Math.random()) * 0x10000 | 0).toString(16).substring(1);
      }
      return S4() + S4() + S4() + S4() + S4() + S4() + S4() + S4();
    },
    handlerPopup: function handlerPopup(captchaObj) {
      var _this = this;
      captchaObj.appendTo('.jtocode');
      captchaObj.onSuccess(function () {
        var validate = captchaObj.getValidate();
        setTimeout(function () {
          _this.codeshow = false;
        }, 1500);
        _this.$http.post(_this.baseUrl + '/login/p/1', { geetest_challenge: validate.geetest_challenge, geetest_validate: validate.geetest_validate, geetest_seccode: validate.geetest_seccode, username: _this.name, password: _this.pas }, { credentials: true }).then(function (res) {
          if (res.body.type === 'success') {
            window.location = _this.ReturnURl;
          } else if (res.body.code === 30000020) {
            captchaObj.reset();
            _this.errorMsg = '验证不成功';
            _this.errorShow = true;
          } else {
            captchaObj.reset();
            _this.errorMsg = '用户名或者密码错误';
            _this.errorShow = true;
          }
        }, function () {
          captchaObj.reset();
          _this.errorMsg = '网络错误，请稍后重试';
          _this.errorShow = true;
        });
      });
    },
    checkMsg: function checkMsg() {
      var _this = this;

      this.$http.post(_this.baseUrl + '/login/need-verify', { username: _this.name }, { credentials: true }).then(function (res) {
        if (res.body.type === 'success') {
          if (res.body.data === true) {
            _this.codeshow = true;
          } else {
            _this.$http.post(_this.baseUrl + '/login/p/1', { username: _this.name, password: _this.pas }, { credentials: true }).then(function (res) {
              if (res.body.type === 'success') {
                window.location = _this.ReturnURl;
              } else {
                _this.errorMsg = '用户名或密码错误';
                _this.errorShow = true;
              }
            }, function () {
              _this.errorMsg = '网络错误，请稍后重试';
              _this.errorShow = true;
            });
          }
        } else {
          _this.errorMsg = '网络错误，请稍后重试';
          _this.errorShow = true;
        }
      }, function () {
        _this.errorMsg = '网络错误，请稍后重试';
        _this.errorShow = true;
      });
    },
    getQQ: function getQQ() {
      var _this = this;
      this.$http.post(_this.baseUrl + '/login/p/4', { redirect_uri: location.href.split('?')[0] + '?name=qq' }, { credentials: true }).then(function (res) {
        if (res.body.type === 'success') {
          window.location = res.body.redirectUrl;
        } else {
          _this.errorMsg = '第三方接口出现问题，请稍后再试';
          _this.errorShow = true;
        }
      }, function () {
        _this.errorMsg = '网络错误，请稍后重试';
        _this.errorShow = true;
      });
    },
    getWEI: function getWEI() {
      var _this = this;
      this.$http.post(_this.baseUrl + '/login/p/3', { redirect_uri: location.href.split('?')[0] + '?name=wei' }, { credentials: true }).then(function (res) {
        if (res.body.type === 'success') {
          window.location = res.body.redirectUrl;
        } else {
          _this.errorMsg = '第三方接口出现问题，请稍后再试';
          _this.errorShow = true;
        }
      }, function () {
        _this.errorMsg = '网络错误，请稍后重试';
        _this.errorShow = true;
      });
    },
    getBO: function getBO() {
      var _this = this;
      this.$http.post(_this.baseUrl + '/login/p/2', { redirect_uri: location.href.split('?')[0] + '?name=bo' }, { credentials: true }).then(function (res) {
        if (res.body.type === 'success') {
          window.location = res.body.redirectUrl;
        } else {
          _this.errorMsg = '第三方接口出现问题，请稍后再试';
          _this.errorShow = true;
        }
      }, function () {
        _this.errorMsg = '网络错误，请稍后重试';
        _this.errorShow = true;
      });
    },
    loginQQ: function loginQQ() {
      var _this = this;
      this.$http.post(_this.baseUrl + '/login/callback/4', { code: _this.code, redirect_uri: location.href.split('?')[0] + '?name=qq' }, { credentials: true }).then(function (res) {
        if (res.body.type === 'success') {
          window.location = _this.ReturnURl;
        } else if (res.body.code === 11000001) {
          _this.errorMsg = '第三方登录用户属性缺失，需要注册';
          window.location = './register?type=others&ReturnURL=' + _this.ReturnURl;
          _this.errorShow = true;
        } else if (res.body.code === 11100000) {
          _this.errorMsg = '第三方登录用户需要注册';
          window.location = './register?type=others&ReturnURL=' + _this.ReturnURl;
          _this.errorShow = true;
        } else {
          _this.errorMsg = '第三方接口出现问题，请稍后再试';
          _this.errorShow = true;
        }
      }, function () {
        _this.errorMsg = '网络错误，请稍后重试';
        _this.errorShow = true;
      });
    },
    loginWEI: function loginWEI() {
      var _this = this;
      this.$http.post(_this.baseUrl + '/login/callback/3', { code: _this.code }, { credentials: true }).then(function (res) {
        if (res.body.type === 'success') {
          window.location = _this.ReturnURl;
        } else if (res.body.code === 11000001) {
          _this.errorMsg = '第三方登录用户属性缺失，需要注册';
          window.location = './register?type=others&ReturnURL=' + _this.ReturnURl;
          _this.errorShow = true;
        } else if (res.body.code === 11100000) {
          _this.errorMsg = '第三方登录用户需要注册';
          window.location = './register?type=others&ReturnURL=' + _this.ReturnURl;
          _this.errorShow = true;
        } else {
          _this.errorMsg = '第三方接口出现问题，请稍后再试';
          _this.errorShow = true;
        }
      }, function () {
        _this.errorMsg = '网络错误，请稍后重试';
        _this.errorShow = true;
      });
    },
    loginBO: function loginBO() {
      var _this = this;
      this.$http.post(_this.baseUrl + '/login/callback/4', { code: _this.code }, { credentials: true }).then(function (res) {
        if (res.body.type === 'success') {
          window.location = _this.ReturnURl;
        } else if (res.body.code === 11000001) {
          _this.errorMsg = '第三方登录用户属性缺失，需要注册';
          window.location = './register?type=others&ReturnURL=' + _this.ReturnURl;
          _this.errorShow = true;
        } else if (res.body.code === 11100000) {
          _this.errorMsg = '第三方登录用户需要注册';
          window.location = './register?type=others&ReturnURL=' + _this.ReturnURl;
          _this.errorShow = true;
        } else {
          _this.errorMsg = '第三方接口出现问题，请稍后再试';
          _this.errorShow = true;
        }
      }, function () {
        _this.errorMsg = '网络错误，请稍后重试';
        _this.errorShow = true;
      });
    },
    changeState: function changeState() {
      this.$emit('changeState');
    },
    forget: function forget() {
      this.$emit('forget');
    }
  }
});

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__agreement_agreement_vue__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__agreement_agreement_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__agreement_agreement_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__successalert_successalert_vue__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__successalert_successalert_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__successalert_successalert_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__js_geetest_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__js_public_js__ = __webpack_require__(9);








/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_4__js_public_js__["a" /* default */]],
  data: function data() {
    return {
      show: false,
      errorShow: false,
      errorMsg: '',
      email: '',
      password: '',
      telphone: '',
      code: '',
      id: '',
      codeshow: false,
      sendMsg: '发送验证码',
      onoff: true,
      alertshow: false,
      msg: '恭喜你，注册成功！',
      type: ''
    };
  },
  created: function created() {
    var _this = this;
    this.id = this.uuid();
    this.type = this.getUrlFn('type');
    __WEBPACK_IMPORTED_MODULE_3_jquery___default.a.ajax({
      url: _this.baseUrl + '/geetest/v3',
      type: 'POST',
      dataType: 'json',
      data: { id: _this.id },
      xhrFields: {
        withCredentials: true
      },
      success: function success(res) {
        if (res.type === 'success') {
          window.initGeetest({
            gt: res.data.gt,
            challenge: res.data.challenge,
            new_captcha: res.data.new_captcha,
            product: 'popup',
            width: '100%',
            offline: !res.data.success
          }, _this.handlerPopup);
        }
      }
    });
  },

  components: {
    agreement: __WEBPACK_IMPORTED_MODULE_0__agreement_agreement_vue___default.a,
    successalert: __WEBPACK_IMPORTED_MODULE_1__successalert_successalert_vue___default.a
  },
  methods: {
    agree: function agree() {
      this.onoff = true;
      this.alertshow = false;
    },
    unagree: function unagree() {
      this.onoff = false;
      this.alertshow = false;
    },
    close: function close() {
      this.alertshow = false;
    },
    alertFn: function alertFn() {
      this.alertshow = true;
    },
    uuid: function uuid() {
      function S4() {
        return ((1 + Math.random()) * 0x10000 | 0).toString(16).substring(1);
      }
      return S4() + S4() + S4() + S4() + S4() + S4() + S4() + S4();
    },
    handlerPopup: function handlerPopup(captchaObj) {
      var _this = this;
      captchaObj.appendTo('.jtocode');
      captchaObj.onSuccess(function () {
        var validate = captchaObj.getValidate();
        setTimeout(function () {
          _this.codeshow = false;
        }, 1500);
        _this.$http.post(_this.baseUrl + '/common/exist-user', { u: _this.telphone }).then(function (res) {
          if (res.body.type === 'success') {
            if (res.body.data) {
              _this.errorMsg = '该手机号已经注册';
              _this.errorShow = true;
              captchaObj.reset();
            } else {
              __WEBPACK_IMPORTED_MODULE_3_jquery___default.a.ajax({
                url: _this.baseUrl + '/register/send/4',
                type: 'POST',
                dataType: 'json',
                data: { geetest_challenge: validate.geetest_challenge, geetest_validate: validate.geetest_validate, geetest_seccode: validate.geetest_seccode, mobile: _this.telphone },
                xhrFields: {
                  withCredentials: true
                },
                success: function success(data) {
                  if (data.type === 'success') {
                    _this.toCode();
                    captchaObj.reset();
                  } else {
                    _this.errorMsg = '操作频繁，请稍后再试';
                    _this.errorShow = true;
                  }
                }
              });
            }
          }
        }, function () {
          _this.errorMsg = '网络错误，请稍后重试';
          _this.errorShow = true;
        });
      });
    },
    toCode: function toCode() {
      var _this = this;
      var i = 60;
      this.sendMsg = i + '秒';
      var nu = setInterval(function () {
        i--;
        _this.sendMsg = i + '秒';
        if (i === 0) {
          clearInterval(nu);
          _this.sendMsg = '发送验证码';
        }
      }, 1000);
    },
    sendyzm: function sendyzm() {
      var phonetest = /^1[0-9]{10}$/;
      if (this.sendMsg.length !== 5) {
        return;
      }
      if (!phonetest.test(this.telphone)) {
        this.errorMsg = '请输入正确的手机号码';
        this.errorShow = true;
        return;
      }
      this.errorShow = false;
      this.codeshow = true;
    },
    submit: function submit() {
      var _this = this;
      var phonetest = /^1[0-9]{10}$/;
      var emailtest = /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
      var re = /^\d+$/;
      var re1 = /^[a-zA-Z]+$/;
      var re2 = /^[`~!@#\$%\^&\*\(\)_\+<>\?:"\{\},\.\\\/;'\[\]！。；、’“”]+$/;
      var val = this.password;
      var len = val.length;
      if (!this.onoff) {
        this.errorMsg = '请阅读并同意 《图灵用户协议》';
        this.errorShow = true;
        return;
      }
      if (!emailtest.test(this.email)) {
        this.errorMsg = '请输入正确邮箱格式';
        this.errorShow = true;
        return;
      }
      if (!phonetest.test(this.telphone)) {
        this.errorMsg = '请输入正确的手机号码';
        this.errorShow = true;
        return;
      }
      if (re.test(val) || re1.test(val) || re2.test(val) || len > 16 || len < 6) {
        this.errorMsg = '密码需要6-16位，且必须包含两种以上字符';
        this.errorShow = true;
        return;
      }
      if (!this.code) {
        this.errorMsg = '验证码不能为空';
        this.errorShow = true;
        return;
      }
      this.errorShow = false;

      this.$http.post(_this.baseUrl + '/common/exist-user', { u: _this.email }, { credentials: true }).then(function (res) {
        if (res.body.type === 'success') {
          if (res.body.data === true) {
            _this.errorMsg = '该邮箱已经注册';
            _this.errorShow = true;
          } else {
            _this.$http.post(_this.baseUrl + '/common/exist-user', { u: _this.telphone }, { credentials: true }).then(function (res) {
              if (res.body.type === 'success') {
                if (res.body.data === true) {
                  _this.errorMsg = '该手机已经注册';
                  _this.errorShow = true;
                } else {
                  _this.$http.post(_this.baseUrl + '/register/validate/1', { mobile: _this.telphone, code: _this.code }, { credentials: true }).then(function (res) {
                    if (res.body.type === 'success') {
                      var url = _this.type === 'others' ? _this.baseUrl + '/register/save/3' : _this.baseUrl + '/register/save/4';
                      _this.$http.post(url, {
                        email: _this.email,
                        mobile: _this.telphone,
                        code: _this.code,
                        password: _this.password,
                        auto_login: true,
                        redirect_uri: '',
                        referer: _this.ReturnURl
                      }, { credentials: true }).then(function (res) {
                        if (res.body.type === 'success') {
                          _this.show = true;
                          window.location = _this.ReturnURl;
                        } else {
                          _this.errorMsg = '验证码错误';
                          _this.errorShow = true;
                        }
                      }, function () {
                        _this.errorMsg = '网络错误，请稍后重试';
                        _this.errorShow = true;
                      });
                    } else {
                      _this.errorMsg = '验证码错误';
                      _this.errorShow = true;
                    }
                  }, function () {
                    _this.errorMsg = '网络错误，请稍后重试';
                    _this.errorShow = true;
                  });
                }
              }
            }, function () {
              _this.errorMsg = '网络错误，请稍后重试';
              _this.errorShow = true;
            });
          }
        }
      }, function () {
        _this.errorMsg = '网络错误，请稍后重试';
        _this.errorShow = true;
      });
    }
  }
});

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    show: Boolean,
    msg: String
  }
});

/***/ }),
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 92 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 93 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 94 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 95 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 96 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 97 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 98 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/icon3.73bc5b3.png";

/***/ }),
/* 100 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(92)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(52),
  /* template */
  __webpack_require__(104),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2e1f28cb",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(97)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(55),
  /* template */
  __webpack_require__(109),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7bf61b56",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 103 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "find-pas"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.model == 'first'),
      expression: "model=='first'"
    }]
  }, [_c('div', {
    staticClass: "top"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone),
      expression: "phone"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入正确的手机号码/邮箱"
    },
    domProps: {
      "value": (_vm.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.jcshow),
      expression: "jcshow"
    }],
    staticClass: "jtocode"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errorShow),
      expression: "errorShow"
    }],
    staticClass: "wrongs"
  }, [_vm._v(_vm._s(_vm.errorMsg))]), _vm._v(" "), _c('div', {
    staticClass: "login-btn",
    on: {
      "click": _vm.sendMsg
    }
  }, [_vm._v("下一步")])]), _vm._v(" "), (_vm.model == 'second') ? _c('div', [_c('div', {
    staticClass: "top1"
  }), _vm._v(" "), _c('p', {
    staticClass: "tel-msg"
  }, [_vm._v("验证码已发送至您的手机：" + _vm._s(_vm.phone.substr(0, 3) + '****' + _vm.phone.substr(7, 4)))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.code),
      expression: "code"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入收到的验证码"
    },
    domProps: {
      "value": (_vm.code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.code = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errorShow),
      expression: "errorShow"
    }],
    staticClass: "wrongs"
  }, [_vm._v(_vm._s(_vm.errorMsg))]), _vm._v(" "), _c('div', {
    staticClass: "login-btn",
    on: {
      "click": _vm.subcode
    }
  }, [_vm._v("提交验证码")]), _vm._v(" "), _c('p', {
    staticClass: "end-msg"
  }, [_vm._v("未收到验证码？请"), _c('span', {
    staticClass: "red"
  }, [_vm._v(_vm._s(_vm.sendNum))]), _vm._v("s后 "), _c('span', {
    staticClass: "blue",
    on: {
      "click": _vm.resend
    }
  }, [_vm._v("重新发送")]), _vm._v(" 验证码或尝试 "), _c('span', {
    staticClass: "blue",
    on: {
      "click": _vm.resendno
    }
  }, [_vm._v("重新输入")]), _vm._v(" 手机号码")])]) : _vm._e(), _vm._v(" "), (_vm.model == 'third') ? _c('div', [_c('div', {
    staticClass: "top1"
  }), _vm._v(" "), _c('div', {
    staticClass: "email-suc"
  }, [_c('p', {
    staticClass: "end-msg center"
  }, [_vm._v("确认邮件已发送至您的邮箱：" + _vm._s(_vm.phone))]), _vm._v(" "), _c('p', {
    staticClass: "end-msg center"
  }, [_vm._v("未收到验证码？请"), _c('span', {
    staticClass: "red"
  }, [_vm._v(_vm._s(_vm.sendNum))]), _vm._v("s后 "), _c('span', {
    staticClass: "blue",
    on: {
      "click": _vm.resend
    }
  }, [_vm._v("重新发送")]), _vm._v(" 验证码或尝试 "), _c('span', {
    staticClass: "blue",
    on: {
      "click": _vm.resendno
    }
  }, [_vm._v("重新输入")]), _vm._v(" 邮箱")])])]) : _vm._e(), _vm._v(" "), (_vm.model == 'four') ? _c('div', [_c('div', {
    staticClass: "top2"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pass),
      expression: "pass"
    }],
    attrs: {
      "type": "password",
      "placeholder": "请输入新密码"
    },
    domProps: {
      "value": (_vm.pass)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pass = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.repass),
      expression: "repass"
    }],
    attrs: {
      "type": "password",
      "placeholder": "请再次输入新密码"
    },
    domProps: {
      "value": (_vm.repass)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.repass = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errorShow),
      expression: "errorShow"
    }],
    staticClass: "wrongs"
  }, [_vm._v(_vm._s(_vm.errorMsg))]), _vm._v(" "), _c('div', {
    staticClass: "login-btn",
    on: {
      "click": _vm.sure
    }
  }, [_vm._v("确定")])]) : _vm._e(), _vm._v(" "), _c('successalert', {
    attrs: {
      "show": _vm.show,
      "msg": _vm.msg
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 104 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.alertshow) ? _c('div', {
    staticClass: "alert"
  }, [_c('div', {
    staticClass: "con"
  }, [_c('div', {
    staticClass: "tit"
  }, [_vm._v("用户服务协议")]), _vm._v(" "), _c('div', {
    staticClass: "btm"
  }, [_c('div', {
    staticClass: "fal",
    on: {
      "click": _vm.unagree
    }
  }, [_vm._v("拒绝")]), _vm._v(" "), _c('div', {
    staticClass: "tru",
    on: {
      "click": _vm.agree
    }
  }, [_vm._v("同意")])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('span', {
    on: {
      "click": _vm.close
    }
  }, [_vm._v("×")])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrap"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('p', {
    staticClass: "p1"
  }, [_vm._v("        图灵科技依据本协议提供语义解析服务，本协议在使用者和图灵科技间具有合同上的法律效力。\n          使用者一经注册或使用本协议下任何服务即视为对本协议条款的理解和接受， 使用者违反本协议时图灵科技有权按其违反情况限制或停止向使用者提供语义解析服务，并有权追究使用者的相关责任。\n          本协议可由图灵科技随时更新，使用者可在图灵机器人查阅最新版协议内容。\n          如在图灵科技修改协议后，使用者不接受修改后的协议，请立即停止使用语义解析服务，如使用者继续使用语义解析服务，将视为已接受修改后的协议。")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("授权内容")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("       本协议的授权产品是图灵科技NGLP，是指采用了图灵科技拥有自主知识产权的语义解析技术的解析平台。其主要功能包括句子分词、单词解析和NER。")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("双方的权利义务")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("1、使用者承诺确保图灵科技NGLP在其产品中正常使用，即保证图灵科技NGLP的句子分词、单词解析和NER等功能能够正常使用，否则视为违约行为。")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("\n          2、为保证图灵科技NGLP的合法使用，使用者集成图灵科技NGLP的产品上市前，须把该产品在图灵机器人网站激活，未经图灵科技审核的帐号将无法使用解析服务，经图灵科技审核通过的产品才能正式上线。 ")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("\n          3、使用者申请图灵科技NGLP时，在图灵机器人所填写的联系方式等信息和提交应用审核的信息等都是准确有效的，并且使用者所申请的图灵科技NGLP只能使用在申请信息所对应的产品中。若有多个产品，使用者应分多次申请图灵科技NGLP，否则视为违约行为。")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("\n          4、使用者在所有涉及图灵科技NGLP的介绍中（应包括但不限于软件帮助文档、产品使用说明书、产品包装、宣传彩页、网站、广告），需指明图灵科技NGLP由“图灵科技”提供，在涉及语义解析技术介绍界面中，需注明“语义解析技术由图灵科技提供”。")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("\n          5、使用者在未经图灵科技书面同意前，不得对图灵科技NGLP中技术软件或文件或其任何部分进行单独销售、转让、出租、转授权；并不得从事反汇编、反编辑以及分解、分析、修改以上软件的行为。 ")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("知识产权")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("1、图灵科技保证，本协议中图灵科技NGLP所涉及的知识产权全部归图灵科技所有，为图灵科技开发、设计，并无抄袭、仿冒、节录或改编他人相同或相似功能软件或其它侵害他人著作权。")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("2、图灵科技保证任何第三方都不能因使用者按本协议约定方式生产、销售、使用了图灵科技NGLP而向使用者索取任何权利或要求。")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("3、所有一方专有的和非公开的知识，方法以及其它信息，在开发过程中为另一方获知或者得到，知识产权仍归原有一方所有。")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("4、图灵科技保证，本协议中所涉及的合作标的的知识产权不存在任何瑕疵，不会侵犯任何第三方的合法权益。")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("保密条款")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("\n          1、图灵科技采取一切措施严格保护使用者提交的资料，在事先没有得到使用者书面同意时不得向任何第三方以任何形式泄漏任何资料。资料应包括但不限于双方提供的一切设计开发有关的信息、结果，以及协议联系期间双方或双方代表与对方交流的对方以前未知的信息。")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("\n          2、图灵科技不允许任何人在未经使用者同意的情况利用图灵科技提供的服务以任何手段编辑、出售、传播使用者的资料。一经发现使用者实施上述行为，图灵科技有权立即终止与该使用者的服务协议，终止为其提供任何语义解析服务，并有权追究其法律责任。")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("协议终止")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("1、如遇下列情况之一，经一方发出书面通知后即可提前终止协议：")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v(" • 任何一方严重违反本协议的实质性义务，经守约方书面通知（书面形式包括通知函、传真、以及邮件等方式）后，在规定期限内未能采取有效的补救措施以纠正违约行为的；")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("• 除适用破产法所禁止的情形外，如果任何一方出于债权人的利益，已被指定接收人或资产受让人、或破产或无力偿付到期债务或因其他事由丧失履约能力； ")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("本协议无论因何种原因终止后，本协议保密、知识产权、抗辩、违约责任及其他依其性质应继续有效的条款应继续有效，并不损害受损方寻求其它救济的权利。 ")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("2、使用者应按照图灵科技的标准规定使用NGLP，如使用者出现违反授权协议条约的行为，则图灵科技有权停止向使用者提供语义解析服务。")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("免责条款")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("       鉴于语义解析服务需要网络支撑，图灵科技有权对提供网路服务的平台或相关设备进行部分或全部的维护、切换，如因此类情况造成的网络服务在一定时间内出现中断，图灵科技无需通知使用者，也无需承担任何责任。")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("其它条款")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("1、图灵科技对本协议条款拥有解释权。")]), _vm._v(" "), _c('p', {
    staticClass: "p1",
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_vm._v("2、执行本协议所发生的以及与本协议有关的一切争议，双方友好协商解决，若协商不成，双方同意提交图灵科技所在地人民法院诉讼解决")])])])
}]}

/***/ }),
/* 105 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('v-header', {
    attrs: {
      "name": _vm.name,
      "onoff": _vm.onoff
    },
    on: {
      "loginFn": _vm.loginFn
    }
  }), _vm._v(" "), _c('router-view', {
    on: {
      "changeState": _vm.changest,
      "forget": _vm.forget
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "btm"
  }, [_vm._v("Copyright © 2015 图灵机器人 All rights Reserved ")])], 1)
},staticRenderFns: []}

/***/ }),
/* 106 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show) ? _c('div', {
    staticClass: "success"
  }, [_c('div', {
    staticClass: "con"
  }, [_vm._v("\n    " + _vm._s(_vm.msg) + "\n  ")])]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login"
  }, [_c('div', {
    staticClass: "login-wrapper"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "r con-wrap"
  }, [_c('p', {
    staticClass: "tit"
  }, [_vm._v("账号登录")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    staticClass: "name",
    attrs: {
      "type": "text",
      "placeholder": "输入用户名/手机号/注册邮箱进行登录",
      "maxlength": "50"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pas),
      expression: "pas"
    }],
    staticClass: "pas",
    attrs: {
      "type": "password",
      "placeholder": "输入密码",
      "maxlength": "50"
    },
    domProps: {
      "value": (_vm.pas)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.checkMsg($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pas = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errorShow),
      expression: "errorShow"
    }],
    staticClass: "wrong"
  }, [_vm._v(_vm._s(_vm.errorMsg))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.codeshow),
      expression: "codeshow"
    }],
    staticClass: "jtocode"
  }), _vm._v(" "), _c('div', {
    staticClass: "login-btn",
    on: {
      "click": _vm.checkMsg
    }
  }, [_vm._v("登录")]), _vm._v(" "), _c('div', {
    staticClass: "hrefs clearfix"
  }, [_c('router-link', {
    staticClass: "res",
    attrs: {
      "to": {
        name: 'register'
      }
    }
  }, [_c('span', {
    on: {
      "click": _vm.changeState
    }
  }, [_vm._v("立即注册")])]), _vm._v(" "), _c('router-link', {
    staticClass: "forget",
    attrs: {
      "to": {
        name: 'findPas'
      }
    }
  }, [_c('span', {
    on: {
      "click": _vm.forget
    }
  }, [_vm._v("忘记密码")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "login-way"
  }, [_vm._v("使用第三方账号登陆")]), _vm._v(" "), _c('div', {
    staticClass: "elLogin"
  }, [_c('a', {
    staticClass: "el1",
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.getQQ
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "el2",
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.getWEI
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "el3",
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.getBO
    }
  })])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "l"
  }, [_c('div', [_c('span', [_vm._v("快速创建您的个性化机器人只需四步")]), _vm._v(" "), _c('img', {
    staticClass: "img",
    attrs: {
      "src": __webpack_require__(99),
      "alt": ""
    }
  })])])
}]}

/***/ }),
/* 108 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "find-pas"
  }, [_c('div', {
    staticClass: "top2"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pass),
      expression: "pass"
    }],
    attrs: {
      "type": "password",
      "placeholder": "请输入新密码"
    },
    domProps: {
      "value": (_vm.pass)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pass = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.repass),
      expression: "repass"
    }],
    attrs: {
      "type": "password",
      "placeholder": "请再次输入新密码"
    },
    domProps: {
      "value": (_vm.repass)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.repass = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errorShow),
      expression: "errorShow"
    }],
    staticClass: "wrongs"
  }, [_vm._v(_vm._s(_vm.errorMsg))]), _vm._v(" "), _c('div', {
    staticClass: "login-btn",
    on: {
      "click": _vm.sure
    }
  }, [_vm._v("确定")]), _vm._v(" "), _c('successalert', {
    attrs: {
      "show": _vm.show,
      "msg": _vm.msg
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "page-name"
  }, [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), (_vm.onoff) ? _c('div', {
    staticClass: "rooter",
    on: {
      "click": _vm.loginFn
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'login'
      }
    }
  }, [_vm._v("立即登录")])], 1) : _vm._e(), _vm._v(" "), (!_vm.onoff) ? _c('div', {
    staticClass: "rooter",
    on: {
      "click": _vm.loginFn
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'register'
      }
    }
  }, [_vm._v("立即注册")])], 1) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "has-account"
  }, [_vm._v(_vm._s(!_vm.onoff ? '未有账号？' : '已有账号？'))])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": __webpack_require__(100),
      "alt": ""
    }
  })])
}]}

/***/ }),
/* 110 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "register"
  }, [_c('div', {
    staticClass: "login-wrapper"
  }, [_c('div', {
    staticClass: "r con-wrap"
  }, [_c('p', {
    staticClass: "tit"
  }, [_vm._v("注册新账号")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    attrs: {
      "type": "text",
      "placeholder": "邮箱"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "type": "password",
      "placeholder": "密码"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.telphone),
      expression: "telphone"
    }],
    attrs: {
      "type": "text",
      "placeholder": "手机号"
    },
    domProps: {
      "value": (_vm.telphone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.telphone = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "yz clearfix"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.code),
      expression: "code"
    }],
    staticClass: "yz-inp",
    attrs: {
      "type": "text",
      "placeholder": "验证码"
    },
    domProps: {
      "value": (_vm.code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.code = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sent",
    on: {
      "click": _vm.sendyzm
    }
  }, [_vm._v(_vm._s(_vm.sendMsg))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.codeshow),
      expression: "codeshow"
    }],
    staticClass: "jtocode"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errorShow),
      expression: "errorShow"
    }],
    staticClass: "wrong"
  }, [_vm._v(_vm._s(_vm.errorMsg))]), _vm._v(" "), _c('div', {
    staticClass: "read"
  }, [_c('span', [_c('label', {
    attrs: {
      "for": "sel"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.onoff),
      expression: "onoff"
    }],
    attrs: {
      "type": "checkbox",
      "name": "",
      "id": "sel"
    },
    domProps: {
      "checked": Array.isArray(_vm.onoff) ? _vm._i(_vm.onoff, null) > -1 : (_vm.onoff)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.onoff,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.onoff = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.onoff = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.onoff = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "selbox",
    class: _vm.onoff ? 'active' : ''
  }), _vm._v("阅读并同意\n          ")]), _vm._v(" "), _c('span', {
    staticClass: "col",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.alertFn($event)
      }
    }
  }, [_vm._v("《图灵用户协议》")])])]), _vm._v(" "), _c('div', {
    staticClass: "login-btn",
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("注册")])])]), _vm._v(" "), _c('agreement', {
    attrs: {
      "alertshow": _vm.alertshow
    },
    on: {
      "close": _vm.close,
      "agree": _vm.agree,
      "unagree": _vm.unagree
    }
  }), _vm._v(" "), _c('successalert', {
    attrs: {
      "show": _vm.show,
      "msg": _vm.msg
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 111 */,
/* 112 */,
/* 113 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
],[50]);


// WEBPACK FOOTER //
// static/js/app.855d9c5b52c790361d65.js